(function () {
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' $';
  }
  function activeSlide(card) {
    return card.querySelector('.bk-slide.is-active');
  }
  function initRoot(root) {
    if (!root || root.dataset.bkInit) return;
    root.dataset.bkInit = '1';
    var cards = root.querySelectorAll('.bk-card');
    var totalEl = root.querySelector('[data-total-value]');
    var addBtn = root.querySelector('[data-add-ensemble]');
    var addHint = root.querySelector('[data-add-hint]');
    var confirmEl = root.querySelector('[data-confirm]');

    function recalc() {
      var sum = 0, chosen = 0;
      cards.forEach(function (card) {
        var vid = card.getAttribute('data-variant-id');
        if (!vid) return;
        chosen += 1;
        sum += parseInt(card.getAttribute('data-price') || '0', 10);
      });
      var ok = chosen === cards.length && cards.length > 0;
      if (totalEl) totalEl.textContent = ok ? money(sum) : '—';
      if (addBtn) addBtn.disabled = !ok;
      if (addHint) addHint.style.display = ok ? 'none' : '';
    }

    function clearCard(card) {
      card.removeAttribute('data-variant-id');
      card.removeAttribute('data-price');
      var slide = activeSlide(card);
      if (slide) {
        slide.querySelectorAll('.bk-size').forEach(function (b) { b.classList.remove('is-selected'); });
        var pd = slide.querySelector('[data-price-display]');
        if (pd && pd.dataset.base) pd.textContent = pd.dataset.base;
        var hint = slide.querySelector('[data-hint]');
        if (hint) hint.style.display = '';
      }
    }

    function selectSize(card, btn) {
      var slide = activeSlide(card);
      if (slide) slide.querySelectorAll('.bk-size').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      card.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
      card.setAttribute('data-price', btn.getAttribute('data-price'));
      if (slide) {
        var pd = slide.querySelector('[data-price-display]');
        if (pd) pd.textContent = money(parseInt(btn.getAttribute('data-price') || '0', 10));
        var hint = slide.querySelector('[data-hint]');
        if (hint) hint.style.display = 'none';
      }
      recalc();
    }

    function move(card, dir) {
      var slides = Array.prototype.slice.call(card.querySelectorAll('.bk-slide'));
      if (slides.length < 2) return;
      var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      slides[i].classList.remove('is-active');
      i = (i + dir + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      var idxEl = card.querySelector('[data-idx]');
      if (idxEl) idxEl.textContent = i + 1;
      clearCard(card);
      recalc();
    }

    cards.forEach(function (card) {
      var prev = card.querySelector('.bk-prev');
      var next = card.querySelector('.bk-next');
      if (prev) prev.addEventListener('click', function () { move(card, -1); });
      if (next) next.addEventListener('click', function () { move(card, 1); });
      card.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.bk-size') : null;
        if (btn && !btn.disabled && card.contains(btn)) selectSize(card, btn);
      });
    });

    function refreshCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count], cart-icon .cart-bubble, .cart-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        try {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        } catch (e) {}
      }).catch(function () {});
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [], valid = true;
      cards.forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        if (!id) { valid = false; return; }
        items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      if (!valid || items.length < cards.length) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = (window.BK_T && window.BK_T.adding) || 'Ajout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if (confirmEl) confirmEl.hidden = false;
        window.location.href = '/cart';
      }).catch(function () {
        addBtn.textContent = (window.BK_T && window.BK_T.errorRetry) || 'Erreur — réessaie';
        addBtn.disabled = false;
        setTimeout(function () { addBtn.textContent = original; recalc(); }, 2500);
      });
    });

    (function preselectColor() {
      var params = new URLSearchParams(window.location.search);
      var col = (params.get('couleur') || '').toLowerCase();
      if (!col) return;
      cards.forEach(function (card) {
        var slides = Array.prototype.slice.call(card.querySelectorAll('.bk-slide'));
        var target = -1;
        for (var k = 0; k < slides.length; k++) {
          if ((slides[k].getAttribute('data-couleur') || '').toLowerCase() === col) { target = k; break; }
        }
        if (target < 0) return;
        var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        if (cur === target) return;
        if (cur >= 0) slides[cur].classList.remove('is-active');
        slides[target].classList.add('is-active');
        clearCard(card);
      });
    })();

    recalc();
  }
  function boot() {
    document.querySelectorAll('.bk-ensemble').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
